import React, { createContext } from 'react'

export const RateCurrencyContext = createContext(null)
